import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class RoundExpression extends ExpressionRule {
    readonly __type: string = "Round";
    value1: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1");
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return Math.round(this.value1.evaluate(data, testContext));
    }
}
